import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api/client';
import type { Transfer, CreateTransferInput, UpdateTransferInput } from '@aigftpwatch/shared';

export function useTransfers(status?: string, page = 1) {
  const params = new URLSearchParams({ page: String(page) });
  if (status) params.set('status', status);
  return useQuery({
    queryKey: ['transfers', status, page],
    queryFn: () => api.getPaginated<Transfer>(`/transfers?${params}`),
  });
}

export function useTransfer(id: number) {
  return useQuery({
    queryKey: ['transfers', id],
    queryFn: () => api.get<Transfer>(`/transfers/${id}`).then((r) => r.data),
    enabled: !!id,
  });
}

export function useCreateTransfer() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateTransferInput) => api.post<Transfer>('/transfers', data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['transfers'] }),
  });
}

export function useUpdateTransfer() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...data }: UpdateTransferInput & { id: number }) =>
      api.put<Transfer>(`/transfers/${id}`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['transfers'] }),
  });
}

export function useSubmitTransfer() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => api.post(`/transfers/${id}/submit`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['transfers'] }),
  });
}
